import { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { DEAL_STAGE } from '../constants/DealGroupingType';
import { ONBOARDING_FORECAST_TOUR, ONBOARDING_FORECAST_TOUR_WITHOUT_AI, ONBOARDING_V2_TOUR, ONBOARDING_V2_TOUR_WITHOUT_ANALYZE } from '../constants/TourConstants';
import { REP_OVERVIEW } from '../constants/Events';
import { setHasSeenFmoAdminMigrationTour, setHasSeenOnboardingTour } from '../actions/DisplayOptionsActions';
import { getDealGroupingTypeFilter } from '../selectors/filtersSelectors';
import { getIsOverviewDataFetching, getIsOverviewDataFetchSuccessful } from '../selectors/overviewSelectors';
import { getHasSeenDealStageForecastTour } from '../selectors/displayOptionsSelectors';
import { getRows } from '../selectors/aggregatedOverviewDataSelectors';
import { getIsUngatedToAIProjections, getIsUngatedToForecastingMultipleOutcomes } from '../selectors/authSelectors';
import { trackShowOnboardingIntroModal, trackStartUITour } from '../utils/usageTracker';
import { getIsDealStageView } from '../selectors/forecastSelectors';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
export default function useOnboardingIntroModal({
  setSeenWithStartTour
} = {
  setSeenWithStartTour: false
}) {
  const dispatch = useDispatch();
  const {
    tour
  } = useContext(TourContext);
  const isOverviewDataFetching = useSelector(getIsOverviewDataFetching);
  const isOverviewDataFetchSuccessful = useSelector(getIsOverviewDataFetchSuccessful);
  const hasData = useSelector(getRows).size > 0;
  const dealGroupingType = useSelector(getDealGroupingTypeFilter);
  const hasSeenDealStageForecastTour = useSelector(getHasSeenDealStageForecastTour);
  const isDealStageView = useSelector(getIsDealStageView);
  const isUngatedToAIProjections = useSelector(getIsUngatedToAIProjections);
  const isFmoEnabled = useSelector(getIsUngatedToForecastingMultipleOutcomes);
  const [isOpen, toggleModal] = useState(false);

  // once rep index data is fetched, check if we should show the modal to optionally start the deal stage forecast tour
  useEffect(() => {
    if (!isOverviewDataFetching && isOverviewDataFetchSuccessful && dealGroupingType === DEAL_STAGE && !hasSeenDealStageForecastTour && hasData) {
      trackShowOnboardingIntroModal();
      toggleModal(true);
      if (!setSeenWithStartTour) {
        dispatch(setHasSeenOnboardingTour()).catch(error => logRavenException(error, 'Setting has seen onboarding tour'));
      }
      if (isFmoEnabled) {
        // Avoid showing V2 onboarding back-to-back with the migration tour
        dispatch(setHasSeenFmoAdminMigrationTour()).catch(error => logRavenException(error, 'Setting has seen fmo admin migration tour'));
      }
    }
  }, [setSeenWithStartTour, isDealStageView, isFmoEnabled, isOverviewDataFetching, isOverviewDataFetchSuccessful, dealGroupingType, hasData, hasSeenDealStageForecastTour, toggleModal, dispatch]);
  const startTour = () => {
    if (setSeenWithStartTour) {
      dispatch(setHasSeenOnboardingTour()).catch(error => logRavenException(error, 'Setting has seen onboarding tour'));
    }
    toggleModal(false);
    trackStartUITour(REP_OVERVIEW, isDealStageView);
    if (isUngatedToAIProjections) {
      tour.start(isFmoEnabled ? ONBOARDING_V2_TOUR : ONBOARDING_FORECAST_TOUR);
    } else {
      tour.start(isFmoEnabled ? ONBOARDING_V2_TOUR_WITHOUT_ANALYZE : ONBOARDING_FORECAST_TOUR_WITHOUT_AI);
    }
  };
  return {
    isOpen,
    toggleModal,
    startTour
  };
}